module.exports = __webpack_public_path__ + "img/pois_de_senteur.ea481299.jpg";